import React from 'react';

import { Breadcrumb, BreadcrumbItem } from '../listing/Breadcrumb';

export interface BreadcrumbConfig {
  label: string;
  to?: string;
  href?: string;
  current?: boolean;
  onClick?: () => void;
}

interface PageHeaderProps {
  title: string;
  subtitle?: React.ReactNode;
  breadcrumbs?: BreadcrumbConfig[];
  actions?: React.ReactNode;
  className?: string;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  subtitle,
  breadcrumbs,
  actions,
  className = '',
}) => {
  return (
    <div className={className}>
      <div className="flex flex-wrap items-start justify-between gap-x-4 gap-y-3 min-w-0">
        <div className="min-w-0 flex-1">
          <h1 className="text-2xl font-bold text-neutral-900 dark:text-white truncate">
            {title}
          </h1>

          {subtitle && (
            <div className="mt-2.5 flex items-center gap-2 text-sm text-neutral-600 dark:text-neutral-400 truncate">
              {subtitle}
            </div>
          )}

          {breadcrumbs && breadcrumbs.length > 0 && (
            <Breadcrumb className="mt-1">
              {breadcrumbs.map((item, index) => (
                <BreadcrumbItem
                  key={`${item.label}-${index}`}
                  to={item.to}
                  href={item.href}
                  current={item.current}
                  onClick={item.onClick}
                >
                  {item.label}
                </BreadcrumbItem>
              ))}
            </Breadcrumb>
          )}
        </div>
        {actions && (
          <div className="flex flex-wrap items-center gap-2 justify-start md:justify-end shrink-0 self-end">
            {actions}
          </div>
        )}
      </div>
    </div>
  );
};

export default PageHeader;
